import { useLocation } from 'react-router-dom';
import { isTeacherLoopStandalonePath } from '../../utils/teacherLoopGate';

/**
 * The Teacher Loop's public pages (/check/…, /thanks/<code>, /gift/verify)
 * stand on their own: no MainSidebar even for a signed-in viewer. Follows the
 * router location, so the sidebar comes back as soon as the viewer navigates
 * anywhere else.
 */
export default function HideOnTeacherCheckRoute({ children }) {
  const location = useLocation();
  return isTeacherLoopStandalonePath(location.pathname) ? null : children;
}
